import { combineReducers } from "redux";

import loginForm from "./loginForm";
import logout from "./logout";
import loginPersistReducer from "./login";
import resetQr from "./resetQr";

const authReducer = combineReducers({
  loginForm,
  login: loginPersistReducer,
  logout,
  resetQr,
});

export default authReducer;
